import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Baby(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.667 4C5.58 4 4 5.453 4 7.5c0 1.273.42 2.256 1.082 2.918C5.744 11.08 6.727 11.5 8 11.5c1.498 0 2.78.45 3.568 1.518l.981-.982C10.998 10.738 11 8.897 11 8.051V8c0-2.289-1.475-4-3.333-4zm6.307 6.612C13.037 9.934 13 8.922 13 8c0-3.027-2.037-6-5.333-6C4.597 2 2 4.231 2 7.5c0 1.727.58 3.244 1.668 4.332C4.756 12.92 6.273 13.5 8 13.5c1.272 0 1.833.403 2.106.947a.793.793 0 00.011.023A4 4 0 009 17.243V21a1 1 0 001.707.707l2.054-2.054a5 5 0 106.892-6.892l2.054-2.054A1 1 0 0021 9h-3.757a4 4 0 00-2.829 1.172l-.44.44zm4.201 3.627l-3.936 3.937.006.015a3 3 0 103.93-3.952zm-2.347-2.653A2 2 0 0117.243 11h1.343L11 18.586v-1.343a2 2 0 01.586-1.415l4.242-4.242z",
    clipRule: "evenodd"
  }));
}

export default Baby;